var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allnews-page"},[_c('Article'),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }